import moment from "moment";
import RoutingPaths from "./RoutingPaths";
import { Link } from "react-router-dom";

export const isDevMode = () => {
  return process.env.NODE_ENV === "development";
};

export const removeDashboardPath = (path) =>
  path.replace(new RegExp(`^${RoutingPaths.DASHBOARD}`), "");

export const convertDateAndTimeToString = (dateAndTime) => {
  return moment(dateAndTime).format("llll");
};

export const convertDateToString = (timestamp) => {
  const dateAndTime = Number(timestamp);

  const date = new Date(dateAndTime);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const convertDateToStringForCasePaper = (timestamp) => {
  const dateAndTime = Number(timestamp);

  const date = new Date(dateAndTime);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  const optionsDate = {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  };
  const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };

  const formattedDate = date.toLocaleDateString("en-US", optionsDate);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return formattedDate;
  }

  const formattedTime = date.toLocaleTimeString("en-US", optionsTime);
  return `${formattedDate} ${formattedTime}`;
};

export const convertTimeToString = (startTime, endTime, TimingList, i) => {
  const TO_HOURS = 3600000;
  let startTimeHour = Math.floor((startTime / 1000 / 60 / 60) % 24);
  let startTimeMin = Math.floor(((startTime % TO_HOURS) / 1000 / 60) % 60);
  let endTimeHour = Math.floor((endTime / 1000 / 60 / 60) % 24);
  let endTimeMin = Math.floor(((endTime % TO_HOURS) / 1000 / 60) % 60);

  return (
    <p className="mb-0">
      <i className="bi bi-clock-history me-2"></i>
      {startTimeHour < 10
        ? startTimeHour.toString().padStart(2, "0")
        : startTimeHour}
      :
      {startTimeMin < 10
        ? startTimeMin.toString().padStart(2, "0")
        : startTimeMin}{" "}
      to{" "}
      {endTimeHour < 10 ? endTimeHour.toString().padStart(2, "0") : endTimeHour}
      :{endTimeMin < 10 ? endTimeMin.toString().padStart(2, "0") : endTimeMin}
      {i !== TimingList.length - 1 ? "  " : ""}
    </p>
  );
};

export function convertTimeToMilliSecond(timeObj) {
  let startTime =
    Number(timeObj.startHour) * 1000 * 60 * 60 +
    Number(timeObj.startMinute) * 1000 * 60;
  let endTime =
    Number(timeObj.endHour) * 1000 * 60 * 60 +
    Number(timeObj.endMinute) * 1000 * 60;
  return {
    dayOfWeek: timeObj.dayOfWeek,
    startTime: startTime,
    endTime: endTime,
  };
}

export async function downloadFileFromURL({ id, fileName }) {
  const fileUrl = id;
  const desiredFileName = fileName;

  downloadFile(fileUrl, desiredFileName);
}

const downloadFile = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function convertConsultantTimeToString(time) {
  const hours = Math.floor(time / 3600000);
  const minutes = Math.floor((time % 3600000) / 60000);
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
}

export const searchResult = (searchData) => {
  return (
    <span className="text-center">
      Your search for {searchData} didn't match anything.
    </span>
  );
};

export const sortByExerciseName = (exercises) => {
  return exercises.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};

export function copyRight() {
  const startYear = 2024;
  const endYear = moment().year();

  return (
    <div>
      All Rights Reserved{" "}
      <Link to="https://www.nityaobject.com/" target="_blank">
        NityaObject
      </Link>{" "}
      ©{startYear}-{endYear}
    </div>
  );
}

export const standardizeQuestionText = (questionText) => {
  return questionText
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^\w_]+/g, "");
};

export function getDateAfterDays(baseDate, offsetDays) {
  if (!baseDate) return null;

  const date = moment(baseDate, "YYYY-MM-DD");
  if (!date.isValid()) {
    return null;
  }
  const newDate = date.add(offsetDays, "days");
  return newDate.format("YYYY-MM-DD");
}

export const dateManipulation = (date1, date2, operation, unit, value) => {
  const momentDate1 = moment(date1);
  const momentDate2 = moment(date2);

  switch (operation) {
    case "add":
      return momentDate1.add(value, unit).format("YYYY-MM-DD");
    case "subtract":
      return momentDate1.subtract(value, unit).format("YYYY-MM-DD");
    case "difference":
      const diff = momentDate1.diff(momentDate2, unit);
      return diff;
    default:
      console.error(
        'Invalid operation. Use "add", "subtract", or "difference".',
      );
  }
};

export function getAgeFromDOB(dobString) {
  const birthDate = new Date(dobString);
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    months += 12;
    years--;
  }
  let age = { years: years, months: 0, days: 0 };
  if (years >= 2) {
    age = { years: years, months: 0, days: 0 };
  } else if (years < 1) {
    age = { years: years, months: months, days: days };
  } else {
    age = { years: years, months: months, days: 0 };
  }
  return age;
}

export const getSelectedBranchId = () => {
  const value = JSON.parse(sessionStorage.getItem("SelectedBranch"));

  if (value === "ALL") {
    return null;
  }

  return value || null;
};
